(function () {
  const A_DAY = 0.08;
  const B_FAST = 0.12;
  const W_DAY = (2 * Math.PI) / 86400;
  const W_FAST = (2 * Math.PI) / 1873;
  const FIRST_MIN_MS = 1500;
  const FIRST_RANGE_MS = 1500;
  const NEXT_MIN_MS = 5000;
  const NEXT_RANGE_MS = 7000;
  const instances = new Map();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function countAt(nowMs, base, epochMs, avgPerHour) {
    const t = Math.max(0, (nowMs - epochMs) / 1000);
    const r = Math.max(0, avgPerHour) / 3600;
    const integral =
      r *
      (t -
        (A_DAY / W_DAY) * (Math.cos(W_DAY * t) - 1) -
        (B_FAST / W_FAST) * (Math.cos(W_FAST * t) - 1));
    return base + Math.floor(integral);
  }

  function formatCount(n) {
    return Math.floor(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function parseNumber(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function readConfig(section) {
    return {
      base: Math.max(0, parseNumber(section.getAttribute('data-base-count'), 0)),
      epochMs: parseNumber(section.getAttribute('data-epoch'), 0) * 1000,
      avgPerHour: Math.max(0, parseNumber(section.getAttribute('data-avg-per-hour'), 0)),
    };
  }

  function randomDelay(min, range) {
    return min + Math.random() * range;
  }

  function isDigit(ch) {
    return ch >= '0' && ch <= '9';
  }

  function sameLayout(a, b) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (isDigit(a[i]) !== isDigit(b[i])) return false;
    }
    return true;
  }

  function createSep(ch) {
    const sep = document.createElement('span');
    sep.className = 'impact-counter__sep';
    sep.textContent = ch;
    sep.setAttribute('aria-hidden', 'true');
    return sep;
  }

  function createReelItem(n) {
    const item = document.createElement('span');
    item.className = 'impact-counter__reel-item';
    item.textContent = String(n);
    return item;
  }

  function settleReel(reel, digit) {
    reel.textContent = '';
    reel.appendChild(createReelItem(digit));
    reel.style.transition = 'none';
    reel.style.transform = 'translateY(0)';
    reel.setAttribute('data-index', String(digit));
  }

  function createDigit(digitChar) {
    const col = document.createElement('span');
    col.className = 'impact-counter__digit';
    col.setAttribute('aria-hidden', 'true');

    const reel = document.createElement('span');
    reel.className = 'impact-counter__reel';
    const n = parseInt(digitChar, 10) || 0;
    settleReel(reel, n);
    col.appendChild(reel);
    return col;
  }

  function buildOdometer(countEl, formatted) {
    const frag = document.createDocumentFragment();
    for (let i = 0; i < formatted.length; i++) {
      const ch = formatted[i];
      frag.appendChild(isDigit(ch) ? createDigit(ch) : createSep(ch));
    }
    countEl.textContent = '';
    countEl.appendChild(frag);
  }

  function flipDigit(col, toDigit, animate) {
    const reel = col.querySelector('.impact-counter__reel');
    if (!reel) return;

    const from = (parseInt(reel.getAttribute('data-index'), 10) || 0) % 10;
    const to = toDigit % 10;
    if (from === to) return;

    if (reel._onFlipEnd) {
      reel.removeEventListener('transitionend', reel._onFlipEnd);
      reel._onFlipEnd = null;
    }

    if (!animate) {
      settleReel(reel, to);
      return;
    }

    reel.style.transition = 'none';
    reel.textContent = '';
    reel.appendChild(createReelItem(from));
    reel.appendChild(createReelItem(to));
    reel.style.transform = 'translateY(0)';
    reel.setAttribute('data-index', String(to));
    reel.offsetHeight;
    reel.style.transition = '';
    reel.style.transform = 'translateY(-1em)';

    const onEnd = function (event) {
      if (event.propertyName && event.propertyName !== 'transform') return;
      if (event.target !== reel) return;
      reel.removeEventListener('transitionend', onEnd);
      reel._onFlipEnd = null;
      settleReel(reel, to);
    };
    reel._onFlipEnd = onEnd;
    reel.addEventListener('transitionend', onEnd);
  }

  function syncOdometer(countEl, formatted, animate) {
    const built = countEl.querySelector('.impact-counter__digit');
    const previous = countEl.getAttribute('data-formatted') || '';

    if (!built || !sameLayout(previous, formatted)) {
      buildOdometer(countEl, formatted);
      countEl.setAttribute('data-formatted', formatted);
      return;
    }

    const children = countEl.children;
    for (let i = 0; i < formatted.length; i++) {
      const ch = formatted[i];
      const el = children[i];
      if (!el) continue;
      if (!isDigit(ch)) {
        el.textContent = ch;
        continue;
      }
      flipDigit(el, parseInt(ch, 10), animate);
    }

    countEl.setAttribute('data-formatted', formatted);
  }

  function updateLabel(section, formatted) {
    const labelEl = section.querySelector('[data-impact-label]');
    if (!labelEl) return;

    const unitEl = section.querySelector('.impact-counter__hero-unit');
    const unit = unitEl ? unitEl.textContent.trim() : '';
    const label = unit ? formatted + ' ' + unit : formatted;
    if (labelEl.getAttribute('aria-label') !== label) {
      labelEl.setAttribute('aria-label', label);
    }
  }

  function render(section, value, animate) {
    const countEl = section.querySelector('[data-impact-count]');
    if (!countEl) return;

    const formatted = formatCount(value);
    syncOdometer(countEl, formatted, animate && !prefersReducedMotion());
    updateLabel(section, formatted);
  }

  function tick(section, animate) {
    const instance = instances.get(section);
    if (!instance) return;
    const value = countAt(Date.now(), instance.base, instance.epochMs, instance.avgPerHour);
    render(section, value, animate);
  }

  function schedule(section, first) {
    const instance = instances.get(section);
    if (!instance) return;

    const delay = first ? randomDelay(FIRST_MIN_MS, FIRST_RANGE_MS) : randomDelay(NEXT_MIN_MS, NEXT_RANGE_MS);

    instance.timer = setTimeout(function () {
      tick(section, true);
      schedule(section, false);
    }, delay);
  }

  function destroy(section) {
    const instance = instances.get(section);
    if (!instance) return;
    if (instance.timer) {
      clearTimeout(instance.timer);
    }
    instances.delete(section);
  }

  function init(section) {
    if (!section || instances.has(section)) return;
    if (!section.querySelector('[data-impact-count]')) return;

    const config = readConfig(section);
    const instance = {
      base: config.base,
      epochMs: config.epochMs,
      avgPerHour: config.avgPerHour,
      timer: null,
    };
    instances.set(section, instance);

    tick(section, false);
    schedule(section, true);
  }

  function initAll(context) {
    const root = context || document;

    if (root.classList && root.classList.contains('impact-counter')) {
      init(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.impact-counter') : [];
    sections.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = event.target;

    if (root.classList && root.classList.contains('impact-counter')) {
      destroy(root);
    }

    const sections = root.querySelectorAll ? root.querySelectorAll('.impact-counter') : [];
    sections.forEach(destroy);
  });
})();
